import { createMachine, interpret, assign } from "xstate";
import { getGoal } from "../Utils";

const sortGoals = (dir = "DESC") => {
	const isDesc = dir.toLocaleUpperCase() === "DESC";
	if (isDesc) {
		return (a, b) => b.goal - a.goal;
	} else {
		return (a, b) => a.goal - b.goal;
	}
};

const isUnlocked = (goal, total, log = false) => {
	if (log) console.log(`total: ${total}, goal: ${goal}, unlocked: ${total >= goal}`);
	return total >= goal
};

const calculateGoals = ({
	campaign_id,
	goals,
	show_badges,
	shopify_cart_items,
	original,
	subtotal,
	autoDiscountGifts,
	bundlesDiscounts,
	discountCode,
	byQuantity,
	contextCache,
	setShowConfetti
}) => {
	// const descGoals = [...goals].sort(sortGoals("DESC"));
	const ascGoals = [...goals].sort(sortGoals("ASC")).map(goalObject => {
		const { goal: oldGoal, specific_goals } = goalObject;
		const goal = getGoal({ oldGoal, specific_goals, byQuantity })
		return { ...goalObject, goal }
	});
	const goalValue = (goal) => byQuantity ? goal : parseInt(goal * 100);
	const getTotal = (reward_type) => {
		const discountedValue = bundlesDiscounts 
		const total = byQuantity
			? totalItems
			: reward_type === "free_shipping"
				? (window.mu_include_sub_full_price ? totalPrice : subtotal)
				: reward_type === "manual"
					? original + autoDiscountGifts - discountedValue
					: original - discountedValue;
		return total
	}
	const totalItems = shopify_cart_items.filter(({ product_type }) => product_type?.toLowerCase() !== "free_gift").reduce((acc, cur) => acc + cur.quantity, 0);
	const totalPrice = shopify_cart_items.filter(({ product_type }) => product_type?.toLowerCase() !== "free_gift").reduce((acc, cur) => {
		let price;
		if(cur.selling_plan_allocation && cur.selling_plan_allocation.compare_at_price) {
			price = cur.selling_plan_allocation.compare_at_price;
		} else {
			price = cur.price;
		}
		return acc + price * cur.quantity - cur.discounts?.reduce((acc, { amount }) => acc + amount, 0);
	}, 0);
	return ascGoals.map((goalObject, index) => {
		const { goal, reward_type, confetti, confetti_length } = goalObject;
		const total = getTotal(reward_type)
		const unlocked = isUnlocked(goalValue(goal), total);
		const wasLocked = contextCache ? contextCache?.goals[index]?.unlocked === false : true;
		const value = show_badges ? badgeProgressLength(unlocked, ascGoals.length) : Math.min(100, Number(((total / goalValue(goal)) * 100).toFixed(2)));
		const isDescending = contextCache ? contextCache?.goals[index]?.value > value : false;
		const previousGoal = index > 0 ? ascGoals[index - 1] : {};
		if (confetti && !isDescending && unlocked && wasLocked) {
			setShowConfetti(confetti_length);
		}
		return {
			campaign_id,
			key: "atu_goal_" + index,
			textKey: "atu_goal_text_" + index,
			labelKey: "atu_goal_label_" + index,
			goalObject,
			value,
			previousIsUnlocked: previousGoal?.goal || previousGoal?.goal === 0 ? isUnlocked(goalValue(previousGoal.goal), getTotal(previousGoal.reward_type)) : undefined,
			isFirst: index === 0,
			isLast: index === ascGoals.length - 1,
			unlocked
			// animating:false
		};
	});
};

function badgeProgressLength(unlocked, goalsLength){
	const preset = {
		1: 68,
		2: 45,
		3:10,
		4:5,
	}
	return unlocked ? 100 : preset[goalsLength]
}

const HeaderMachine = ({
	campaign_id,
	goals,
	show_badges,
	shopify_cart_items,
	byQuantity,
	original,
	autoDiscountGifts,
	subtotal,
	bundlesDiscounts,
	discountCode,
	contextCache,
	setShowConfetti
}) => {
	// const highestGoal = descGoals[0];
	return createMachine({
		id: "header-machine",
		// initial: "idle",
		context: {
			goals: calculateGoals({
				campaign_id,
				goals,
				show_badges,
				shopify_cart_items,
				original,
				autoDiscountGifts,
				subtotal,
				byQuantity,
				bundlesDiscounts,
				discountCode,
				contextCache,
				setShowConfetti
			})
		}
		// states: {
		// 	idle: {
		// 		on: {
		// 			START_ANIMATION: {
		// 				actions: (context, event) => {
		// 					const goals = {...context}.goals
		//                     goals[event.index].animating = true
		// 					return assign({ goals: goals });
		// 				}
		// 			},
		// 			STOP_ANIMATION: {
		// 				actions: (context, event) => {
		// 					const goals = {...context}.goals
		//                     goals[event.index].animating = false
		// 					return assign({ goals: goals });
		// 				}
		// 			}
		// 		}
		// 	}
		// }
	});
};

export default HeaderMachine;
